import { createSlice } from "@reduxjs/toolkit";

const profileSlice = createSlice({
  name: "data",
  initialState: {
    profile: null,
  },
  reducers: {
    updateProfileData(state, action) {
      state.profile = action.payload;
    },
  },
});

export const { updateProfileData } = profileSlice.actions;

export default profileSlice.reducer;
